<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HuvrMj/tc-custom/9781526737120.jpg?1725275974971" alt="This image is the cover for the book Joachim Peiper and the Nazi Atrocities of 1944"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Joachim Peiper and the Nazi Atrocities of 1944
      </h1>
      <p class="bookDescription body article font2">
        <p>Joachim Peiper held the rank of Obersturmbannführer in Nazi Germany’s fanatical Schutzstaffel, more commonly referred to as the SS. He spent the first two years of the war as an adjutant to the Reichsführer of the Schutzstaffel, and leading member of the Nazi Party, Heinrich Himmler, where he would have witnessed at first hand the construction and implementation of numerous SS policies, many of which would have been in relation to ethnic cleansing and the Holocaust.  In October 1941, having yearned for a chance at combat, he changed roles and became a commander in the Waffen-SS, although he still remained in regular contact with Himmler. As a member of the 1st SS Panzer Division Leibstandarte, he saw service in the Soviet Union, Italy and Belgium.  On 19 September 1943, he and his men were responsible for the murder of twenty-four Italian civilians at the village of Boves. On 17 December 1944, men under his command were responsible for what became known as the Malmedy massacre, involving the murder of eighty-four unarmed American prisoners of war. Following this, between 17 and 20 December, Peiper and his men were involved in the murder of a number of other American soldiers, as well as Belgian civilians.  Peiper was never charged with the atrocities at Boves, but in 1946 he faced an American military tribunal for the Malmedy masssacre. Although found guilty and sentenced to death, his sentence was reduced to life imprisonment but he was eventually released in 1956.  In 1972, Peiper moved to the French village of Troves in north east France. On 14 July 1976, his home was attacked and set on fire. Overcome by smoke, he died in the flames.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Wynn
      </h2>
      
      <p class="authorDescription body article">Stephen is a retired police officer having served with Essex Police as a constable for thirty years between 1983 and 2013. He is married to Tanya and has two sons, Luke and Ross, and a daughter, Aimee. His sons served five tours of Afghanistan between 2008 and 2013 and both were injured. This led to the publication of his first book, Two Sons in a Warzone &#8211;              Afghanistan: The True Story of a Father&#8217;             s Conflict, published in October 2010. Both Stephen&#8217;             s grandfathers served in and survived the First World War, one with the Royal Irish Rifles, the other in the Mercantile Marine, whilst his father was a member of the Royal Army Ordnance Corps during the Second World War. When not writing Stephen can be found walking his three German Shepherd dogs with his wife Tanya, at some unearthly time of the morning, when most normal people are still fast asleep.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?289cc192